const formatHotelCancelationPolicy = (policy) => {
  const newPolicy = policy
    ? policy
        .replace('is refundable', 'are refundable')
        .replace('is not refundable', 'are not refundable')
        .replace('Hour', 'hours')
        .trim()
    : '';
  return newPolicy.charAt(0).toUpperCase() + newPolicy.slice(1);
};

export default formatHotelCancelationPolicy;
